import { cloneViaSigCard } from './clone-sig-card';
import { cloneViaSigEditor } from './clone-sig-editor';
import { cloneToDomain } from './clone-to-domain';
import { cloningSignature } from './cloning-sig';
import { cloningOptions } from './options';
import { sigEditorActions } from './sig-editor-actions';

let cloneSteps = [
  cloningSignature,
  cloneViaSigCard,
  cloningOptions,
  cloneToDomain,
  cloneViaSigEditor,
  sigEditorActions
];

export const CLONE_STEPS = cloneSteps;
